import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";

// 物品測驗題庫（可彈性擴充）
const itemsQuiz = [
  {
    title: "【你的小物件，是黴菌偷偷築巢的私房寶地嗎？】",
    subtitle: "包包",
    image: process.env.PUBLIC_URL + "/img/items-quiz1.webp",
    points: [
      { x: 50, y: 60, correct: true },  // 藍點（正確）
      { x: 60, y: 25, correct: false }, // 紅點
      { x: 35, y: 85, correct: false }, // 紅點
    ],
    info: {
      luluImg: process.env.PUBLIC_URL + "/img/20.webp",
      title: "Lulu防霉小教室",
      content: [
        "⚠️ 為什麼包包會發霉？包包是黴菌的天堂，尤其是青黴菌，以下這些狀況最容易中招：",
        "• 收納前沒晾乾 / 用濕布擦拭後沒風乾👚",
        "• 放在潮濕衣櫃、儲藏室或地板上🧳",
        "• 長時間不打開、不通風🌀",
        "",
        "而發霉不只影響美觀，還會導致：",
        "💔 皮革龜裂、變質、脫皮",
        "😷 引發過敏或氣喘等呼吸道反應",
        "💸 昂貴包包損壞無法修復",
        "",
        "✅ 三步驟預防包包發霉：",
        "1. 定期取出包包通風 / 曬太陽 ☀️",
        "2. 包包收納前確保完全乾燥",
        "3. 使用乾燥劑或除濕盒防潮"
      ]
    }
  },
  {
    title: "【你的小物件，是黴菌偷偷築巢的私房寶地嗎？】",
    subtitle: "水壺蓋",
    image: process.env.PUBLIC_URL + "/img/items-quiz2.webp",
    points: [
      { x: 39, y: 30, correct: true },  // 藍點（正確）
      { x: 65, y: 20, correct: false }, // 紅點
      { x: 65, y: 75, correct: false }, // 紅點
    ],
    info: {
      luluImg: process.env.PUBLIC_URL + "/img/20.webp",
      title: "Lulu防霉小教室",
      content: [
        "你是不是以為只要每天裝開水、沖一沖就沒事了？錯！👀水壺蓋的內側、矽膠圈、螺旋紋都是黴菌最愛的藏身之處！尤其保溫壺 / 吸管壺 / 運動水壺，經常遇到這些狀況：",
        "• 沒完全晾乾就蓋上，悶住濕氣🧊",
        "• 長時間沒拆開清洗，污垢卡在矽膠圈與蓋縫裡🦠",
        "• 有喝含糖飲品卻沒用清潔劑徹底清洗🍹",
        "",
        "像黑黴菌、青黴菌、酵母菌都超愛這種環境，一旦黴菌滋生，可能會導致：",
        "🟢 喝到毒味水 / 有異味殘留",
        "🦠 黴菌孢子隨水入口，長期可能引發腸胃不適、過敏反應",
        "💧 蓋內構件損壞變色，整個水壺報銷！",
        "",
        "✅ 三招遠離水壺蓋黴菌：",
        "1. 每天拆開蓋子與矽膠圈清洗🧽，尤其飲用非純水時！",
        "2. 清洗後完全晾乾再組裝使用",
        "3. 定期用小刷子刷洗細縫，可用稀釋漂白水消毒"
      ]
    }
  },
  {
    title: "【你的小物件，是黴菌偷偷築巢的私房寶地嗎？】",
    subtitle: "皮鞋",
    image: process.env.PUBLIC_URL + "/img/items-quiz3.webp",
    points: [
      { x: 40, y: 65, correct: true },  // 藍點（正確）
      { x: 65, y: 25, correct: false }, // 紅點
      { x: 55, y: 85, correct: false }, // 紅點
    ],
    info: {
      luluImg: process.env.PUBLIC_URL + "/img/20.webp",
      title: "Lulu防霉小教室",
      content: [
        "👞皮鞋不是穿完放鞋櫃就沒事！黴菌早就在鞋面偷偷開花啦～你是不是鞋子濕就丟回鞋櫃，或者好幾個月沒穿的皮鞋一直收著？👀小心，皮革+潮濕+悶熱，等於黴菌天堂三重奏！",
        "像枝孢菌、麴黴菌、青黴菌都超愛皮鞋😰皮鞋發霉會出現：鞋面一層白霧／綠毛／黑點發出酸味或腐味黴菌孢子吸入可能引發過敏、氣喘，皮膚接觸還可能造成真菌感染（尤其足癬）",
        "✅皮鞋防霉三招：",
        "1. 穿過的鞋先晾乾，不能濕濕悶回鞋櫃！☀️",
        "2. 定期拿出來擦拭、透氣，尤其是季節交替前後！🍃",
        "3. 鞋櫃放防霉片，保持除濕環境！"
      ]
    }
  },
  {
    title: "【你的小物件，是黴菌偷偷築巢的私房寶地嗎？】",
    subtitle: "書",
    image: process.env.PUBLIC_URL + "/img/items-quiz4.webp",
    points: [
      { x: 50, y: 75, correct: false },  // 藍點（正確）
      { x: 50, y: 25, correct: false }, // 紅點
      { x: 50, y: 45, correct: true }, // 紅點
    ],
    info: {
      luluImg: process.env.PUBLIC_URL + "/img/20.webp",
      title: "Lulu防霉小教室",
      content: [
        "📚書櫃不是保險箱！黴菌早就在書頁裡偷偷開枝散葉啦～你是不是書本堆得滿滿、靠牆靠窗放，潮濕大氣還忘了關窗？👀小心！紙張本身就是黴菌的最愛素材，濕氣一重，它們就「書中自有黴菌屋」啦！",
        "最常見會長在書上的黴菌有：麴菌、青黴菌，還有枝孢菌～它們會讓書頁發霉、發黃、變脆、出現斑點，還會飄出霉味！吸入孢子久了還可能引發過敏、氣喘、呼吸道問題，尤其是長期處在發霉書堆的房間裡！",
        "✅書本防霉三招：",
        "1. 書櫃別靠牆、要通風，避免潮濕死角🌬️",
        "2. 定期翻動書本、除塵📚",
        "3. 書櫃內放乾燥劑或防霉包，控制濕度"
      ]
    }
  }
];

export default function Items() {
  const [quizIdx, setQuizIdx] = useState(0);
  const [showInfo, setShowInfo] = useState(false);
  const [wrongClick, setWrongClick] = useState(false);
  const [done, setDone] = useState(false);
  const quiz = itemsQuiz[quizIdx];
  const navigate = useNavigate();

  function handlePointClick(point) {
    if (point.correct) {
      setShowInfo(true);
    } else {
      setWrongClick(true);
      setTimeout(() => setWrongClick(false), 600);
    }
  }

  function handleNext() {
    if (quizIdx < itemsQuiz.length - 1) {
      setQuizIdx(quizIdx + 1);
      setShowInfo(false);
      setWrongClick(false);
    } else {
      setDone(true);
    }
  }

  if (done) {
    return (
      <div className="items-quiz-container" style={{ background: '#99C221', minHeight: '100vh', padding: 0 }}>
        <div style={{ display: 'flex', gap: 24, alignItems: 'center', marginBottom: 16, paddingLeft: 20, paddingTop: 20 }}>
          <Link to="/main" style={{ color: '#2b9aff', fontWeight: 700, fontSize: 20, textDecoration: 'none' }}>無黴行動</Link>
          <Link to="/survey" style={{ color: '#2b9aff', fontWeight: 700, fontSize: 18, textDecoration: 'underline' }}>填寫問卷</Link>
        </div>
        <div style={{ maxWidth: 900, margin: '0 auto', background: 'none', borderRadius: 12, padding: 0, textAlign: 'center', minHeight: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
          <div style={{ fontSize: '3rem', fontWeight: 700, margin: '48px 0 0 0', letterSpacing: 2 }}>太棒了！物品篇結束</div>
          <div style={{ display: 'flex', justifyContent: 'center', margin: '48px 0 32px 0' }}>
            <img src={process.env.PUBLIC_URL + '/img/finish.webp'} alt="Lulu thumbs up" style={{ width: 220, height: 220, objectFit: 'contain', background: '#444', borderRadius: '50%' }} />
          </div>
          <div style={{ fontSize: '2.5rem', fontWeight: 500, margin: '0 0 18px 0', letterSpacing: 1 }}>恭喜你找到物品中黴菌喜歡生長的地方！</div>
          <div style={{ fontSize: '2.5rem', fontWeight: 500, margin: '0 0 36px 0', letterSpacing: 1 }}>快去檢查看看你的物品中有沒有這些黴菌吧！</div>
          <div style={{ display: 'flex', justifyContent: 'center', gap: '20px', marginBottom: 48 }}>
            <button
              className="main-btn"
              style={{ background: 'rgba(154, 71, 61, 0.97)', color: 'white', border: 'none', padding: '16px 32px', borderRadius: 8, fontSize: '1.5rem', fontWeight: 700, cursor: 'pointer' }}
              onClick={() => navigate('/diagnosis')}
            >
              去檢查
            </button>
            <button 
              onClick={() => navigate('/main')} 
              style={{ background: 'rgba(154, 71, 61, 0.97)', color: 'white', border: 'none', padding: '16px 32px', borderRadius: 8, fontSize: '1.5rem', fontWeight: 700, cursor: 'pointer' }}
            >
              回首頁
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="items-quiz-container" style={{ background: '#99C221', minHeight: '100vh', padding: '20px' }}>
      <div style={{ display: 'flex', gap: 24, alignItems: 'center', marginBottom: 16 }}>
        <Link to="/main" style={{ color: '#2b9aff', fontWeight: 700, fontSize: 20, textDecoration: 'none' }}>無黴行動</Link>
        <Link to="/survey" style={{ color: '#2b9aff', fontWeight: 700, fontSize: 18, textDecoration: 'underline' }}>填寫問卷</Link>
      </div>
      <div style={{ maxWidth: 900, margin: '0 auto', background: 'white', borderRadius: 12, padding: 40, position: 'relative' }}>
      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
            <div>
              <div style={{ fontSize: '2rem', fontWeight: 700, marginBottom: 8 }}>{quiz.title}</div>
              <div style={{ fontSize: '1.4rem', fontWeight: 500, marginBottom: 12 }}>{quiz.subtitle}</div>
              <div style={{ color: '#444', fontSize: '1rem', marginBottom: 8 }}>《點點看，黴菌在哪裡？》</div>
            </div>
            <img src={process.env.PUBLIC_URL + '/img/03.webp'} alt="Lulu" style={{ width: 120, height: 120, borderRadius: 14, background: '#eee' }} />
        </div>
        <div style={{ position: 'relative', display: 'flex', justifyContent: 'center' }}>
          <img src={quiz.image} alt="quiz content" style={{ width: 340, height: 260, borderRadius: 8, objectFit: 'cover' }} />
          {quiz.points.map((point, index) => (
            <div
              key={index}
              onClick={() => handlePointClick(point)}
              style={{
                position: 'absolute',
                top: `${point.y}%`,
                left: `${point.x}%`,
                width: 28,
                height: 28,
                borderRadius: '50%',
                background: point.correct ? 'rgba(255, 0, 0, 0.7)' : 'rgba(255, 0, 0, 0.7)',
                cursor: 'pointer',
                border: '3px solid white',
                boxShadow: '0 0 10px rgba(0,0,0,0.5)',
                transform: 'translate(-50%, -50%)',
                animation: !point.correct && wrongClick ? 'flash 0.6s' : 'none'
              }}
              title={point.correct ? '正確答案' : '不是這裡'}
            />
          ))}
        </div>

        {showInfo && (
        <div style={{ marginTop: 32, padding: 24, background: '#f8f8e8', borderRadius: 8, border: '2px solid #b0e0e6' }}>
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: 16 }}>
              <img src={quiz.info.luluImg} alt="Lulu" style={{ width: 80, height: 80, marginRight: 24 }} />
              <h3 style={{ fontSize: '2rem', color: '#005f73', margin: 0 }}>{quiz.info.title}</h3>
            </div>
            {quiz.info.content.map((text, i) => <p key={i} style={{ fontSize: '1.2rem', color: '#333', lineHeight: 1.8, margin: '8px 0' }}>{text}</p>)}
          </div>
        )}
        <div style={{ textAlign: 'right', marginTop: 12 }}>
          <button onClick={handleNext} style={{
            background: '#4caf50',
            color: '#fff',
            fontSize: '1.1rem',
            fontWeight: 600,
            padding: '10px 32px',
            border: 'none',
            borderRadius: 8,
            boxShadow: '0 2px 8px #0001',
            cursor: 'pointer',
            marginRight: 8
          }}>
            {quizIdx < itemsQuiz.length - 1 ? '下一題 →' : '完成'}
          </button>
        </div>
      </div>
  </div>);
}
